"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var _Toolbox = _interopRequireDefault(require("../Toolbox"));
var _button = require("../../button");
var _Searchable = _interopRequireDefault(require("../Searchable"));
var _Operator = _interopRequireDefault(require("../Operator"));
var _Bracket = _interopRequireDefault(require("../Bracket"));
var _Function = _interopRequireDefault(require("../Function"));
var _input = require("../../input");
var _icon = _interopRequireDefault(require("../../icon"));
var _helpers = require("../helpers");
var _constants = require("../constants");
var _helpers2 = require("./helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable max-lines-per-function */
var FormulaMember = /*#__PURE__*/function (_Component) {
  function FormulaMember(props) {
    var _this;
    _classCallCheck(this, FormulaMember);
    _this = _callSuper(this, FormulaMember, [props]);
    _defineProperty(_this, "clearFocus", function () {
      _this.setState({
        isFocused: false
      });
    });
    _this.state = {
      isFocused: false
    };
    return _this;
  }
  _inherits(FormulaMember, _Component);
  return _createClass(FormulaMember, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        keysPath = _this$props.keysPath,
        labels = _this$props.labels,
        actions = _this$props.actions,
        errors = _this$props.errors,
        disabled = _this$props.disabled,
        member = _this$props.member,
        formulaOperators = _this$props.formulaOperators,
        noDelete = _this$props.noDelete,
        ruleIndex = _this$props.ruleIndex,
        noFunctions = _this$props.noFunctions;
      var hasError = R.prop([keysPath.join('.')], (0, _utils.flattenObject)(errors));
      var isFocused = this.state.isFocused;
      var type = member.type,
        value = member.value,
        description = member.description,
        displayName = member.displayName;
      var isBaseInFunction = (0, _helpers.isBaseArgumentInFunction)(keysPath);
      var showDelete = !disabled && (0, _helpers.shouldShowDelete)({
        noDelete: noDelete,
        isFocused: isFocused,
        keysPath: keysPath,
        isBaseInFunction: isBaseInFunction,
        type: type
      });
      var showToolboxAndAdd = !disabled && isFocused && type !== _constants.FORMULA_MEMBER_TYPES.textOnly && !R.equals(member.dataType, _constants.DATA_TYPES.NUMERIC);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "formula-element-wrapper formula-".concat(type, "-wrapper"),
        onClick: function onClick(ev) {
          ev.stopPropagation();
          _this2.setState({
            isFocused: true
          });
        },
        onFocus: function onFocus(ev) {
          ev.stopPropagation();
          _this2.setState({
            isFocused: true
          });
        },
        onBlur: this.clearFocus,
        role: "button",
        tabIndex: 0,
        onKeyPress: function onKeyPress(ev) {
          ev.stopPropagation();
          _this2.setState({
            isFocused: true
          });
        }
      }, showDelete && /*#__PURE__*/_react["default"].createElement(_button.Button, {
        disabled: disabled,
        className: "formula-button delete-member",
        onMouseDown: function onMouseDown(ev) {
          ev.stopPropagation();
          actions.deleteFormulaMember(keysPath);
          _this2.clearFocus();
        },
        type: "naked"
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        icon: "ion-android-delete",
        size: 16
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "formula-element"
      }, function () {
        switch (type) {
          case _constants.FORMULA_MEMBER_TYPES.textOnly:
            return /*#__PURE__*/_react["default"].createElement(_input.RichTextarea, {
              ariaDescribedBy: "blockSubtitle",
              value: member.value,
              disabled: disabled,
              error: hasError ? labels.RULES_BUILDER_DETAILS_MISSING : '',
              onChange: function onChange(event) {
                return actions.formulaChange({
                  value: (0, _utils.getEventValue)(event),
                  type: _constants.FORMULA_MEMBER_TYPES.textOnly,
                  description: description,
                  displayName: displayName
                }, keysPath);
              },
              placeholder: labels.RULES_BUILDER_TEXT_ONLY_REWARD_PLACEHOLDER
            });
          case _constants.FORMULA_MEMBER_TYPES.variable:
          case _constants.FORMULA_MEMBER_TYPES.numeric:
          case _constants.FORMULA_MEMBER_TYPES.percentage:
          case _constants.FORMULA_MEMBER_TYPES.empty:
            return /*#__PURE__*/_react["default"].createElement(_Searchable["default"], _extends({
              isFocused: isFocused,
              labels: labels,
              disabled: disabled
            }, member, {
              uniqueKey: member.key,
              error: hasError,
              ruleIndex: ruleIndex,
              formulaChange: function formulaChange(data) {
                return actions.formulaChange(data, keysPath);
              },
              searchableAction: actions.getFormulaOperandValues,
              clearFocus: _this2.clearFocus,
              keysPath: keysPath
            }, (0, _helpers2.setRoundFieldProperties)({
              member: member,
              labels: labels
            })));
          case _constants.FORMULA_MEMBER_TYPES.operator:
            return /*#__PURE__*/_react["default"].createElement(_Operator["default"], {
              disabled: disabled,
              error: hasError,
              value: value,
              labels: labels,
              placeholder: "",
              formulaOperators: formulaOperators,
              formulaChange: function formulaChange(data) {
                return actions.formulaChange(_objectSpread(_objectSpread({}, data), {}, {
                  type: _constants.FORMULA_MEMBER_TYPES.operator
                }), keysPath);
              },
              clearFocus: _this2.clearFocus
            });
          case _constants.FORMULA_MEMBER_TYPES.functionMember:
            return /*#__PURE__*/_react["default"].createElement(_Function["default"], {
              args: member.arguments,
              renderMember: function renderMember(_ref) {
                var otherProps = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
                return /*#__PURE__*/_react["default"].createElement(FormulaMember, _extends({}, _this2.props, otherProps, {
                  noDelete: false
                }));
              },
              formulaChange: function formulaChange(data) {
                return actions.formulaChange(data, keysPath);
              },
              keysPath: keysPath,
              value: (0, _helpers2.renderFunctionLabel)({
                value: value,
                labels: labels
              }),
              disabled: disabled,
              labels: labels
            });
          case _constants.FORMULA_MEMBER_TYPES.parenthesis:
            return /*#__PURE__*/_react["default"].createElement(_Bracket["default"], _extends({}, member, {
              formulaChange: function formulaChange(data) {
                return actions.formulaChange(data, keysPath);
              }
            }));
          default:
            return '';
        }
      }()), showToolboxAndAdd && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_button.Button, {
        disabled: disabled,
        className: "formula-button add-member",
        onMouseDown: function onMouseDown(ev) {
          ev.stopPropagation();
          actions.addFormulaMember(type, keysPath, value);
          _this2.clearFocus();
        },
        type: "naked"
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        icon: "ion-plus",
        size: 16
      })), /*#__PURE__*/_react["default"].createElement(_Toolbox["default"], _extends({}, this.props, {
        noFunctions: [_constants.FORMULA_MEMBER_TYPES.variable, _constants.FORMULA_MEMBER_TYPES.numeric, _constants.FORMULA_MEMBER_TYPES.percentage, _constants.FORMULA_MEMBER_TYPES.textOnly, _constants.FORMULA_MEMBER_TYPES.parenthesis].includes(type) && !isBaseInFunction || noFunctions,
        noBetween: true,
        disabled: disabled,
        noGroups: type === _constants.FORMULA_MEMBER_TYPES.operator || type === _constants.FORMULA_MEMBER_TYPES.textOnly || isBaseInFunction,
        functionsEnabled: !(0, _helpers.hasReachedMaxNestingDept)(keysPath),
        paranthesesEnabled: true,
        focusedPath: [],
        betweenEnabled: true,
        keysPath: keysPath,
        clearFocus: this.clearFocus
      }))));
    }
  }]);
}(_react.Component);
FormulaMember.defaultProps = {
  disabled: false,
  errors: '',
  noDelete: false,
  noFunctions: false
};
FormulaMember.propTypes = {
  noFunctions: _propTypes["default"].bool,
  member: _propTypes["default"].shape({
    type: _propTypes["default"].string,
    dataType: _propTypes["default"].string,
    value: _propTypes["default"].string,
    description: _propTypes["default"].string,
    displayName: _propTypes["default"].string,
    key: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    arguments: _propTypes["default"].arrayOf(_propTypes["default"].arrayOf(_propTypes["default"].shape({
      value: _propTypes["default"].string,
      type: _propTypes["default"].string,
      displayName: _propTypes["default"].string
    })))
  }).isRequired,
  noDelete: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  errors: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({})]),
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  ruleIndex: _propTypes["default"].number.isRequired,
  formulaOperators: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    displayName: _propTypes["default"].string,
    name: _propTypes["default"].string
  })).isRequired,
  actions: _propTypes["default"].objectOf(_propTypes["default"].func).isRequired,
  keysPath: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])), _propTypes["default"].number]).isRequired
};
var _default = exports["default"] = FormulaMember;